import 'ngVue';
import 'ngVue/build/plugins';
import { Btn, Tooltip } from 'uiv';

import './ringbaPortal.servicesModule';

import store from '@/store';

import i18n from '@/i18n';

const angularModule = angular.module('ringbaPortal.components', [
  'ngVue',
  'ngVue.plugins'
]);


angularModule.config($ngVueProvider => {
  $ngVueProvider.setRootVueInstanceProps({
    store,
    i18n,
    components: {
      Btn,
      Tooltip
    }
  });
});


export default angularModule;
